import { observer } from 'mobx-react-lite';

import { FormLabel } from '@components/form-label';
import { Select } from '@components/select';
import { Stack } from '@components/stack';
import { TextEditor } from '@components/text-editor';

import { TextEditorToolbar } from 'components/TextEditorToolbar';
import { usePlaceholderMap } from 'hooks/use-placeholder-map';
import { useStore } from 'models/Provider';

import { FormWrapper } from './styles';

function RejectForm({ isOpen, templates, selected, setEditorState, disabled, onSelect }) {
  const { t } = useStore();
  const placeholderMap = usePlaceholderMap('rejection');

  return (
    <FormWrapper isOpen={isOpen}>
      <Stack space={6}>
        {templates.length > 0 && (
          <RejectTemplateSelector templates={templates} onChange={onSelect} />
        )}

        <Stack space={1}>
          <FormLabel text={t('rejectform.label.message')} />
          <TextEditor
            key={selected.id}
            variant="gray"
            readOnly={disabled}
            initialEditorState={selected.message}
            onChange={setEditorState}
          >
            <Stack orientation="horizontal" justify="space-between" space={2} align="center">
              <TextEditorToolbar />
              <TextEditor.PlaceholderMenu
                label={t('editor.placeholder.title')}
                placeholderMap={placeholderMap}
              />
            </Stack>
            <TextEditor.Input />
          </TextEditor>
        </Stack>
      </Stack>
    </FormWrapper>
  );
}

export default observer(RejectForm);

const RejectTemplateSelector = observer(({ onChange, templates }) => {
  const { t } = useStore();
  const items = templates.map((t) => {
    return {
      value: t.id,
      label: t.title || t.name,
    };
  });
  return (
    <Select
      label={t('rejectform.label.templateselect')}
      placeholder={t('rejectform.template.drop.title')}
      options={items}
      onChange={onChange}
      isClearable={false}
    />
  );
});
